export enum ColumnType {
  CHECKBOX = 'CHECKBOX',
  COLLABORATOR = 'COLLABORATOR',
  CURRENCY = 'CURRENCY',
  DATETIME = 'DATETIME',
  EMAIL = 'EMAIL',
  FORMULA = 'FORMULA',
  LONG_TEXT = 'LONG_TEXT',
  LOOKUP = 'LOOKUP',
  MULTI_ATTACHMENT = 'MULTI_ATTACHMENT',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RATING = 'RATING',
  RECORD_REFERENCE = 'RECORD_REFERENCE',
  ROLLUP = 'ROLLUP',
  SELECT = 'SELECT',
  TEXT = 'TEXT',
  AUTO_NUMBER = 'AUTO_NUMBER',
  NOOP = 'NOOP',
  SUBTABLE = 'SUBTABLE',
}

export interface ISelect {
  color: string;
  name: string;
  optionId: string;
}

export enum DateFormat {
  LOCAL = 'LOCAL',
  FRIENDLY = 'FRIENDLY',
  EURO = 'EURO',
  ISO = 'ISO',
}

export enum TimeFormat {
  TWELVE_HOUR = 'TWELVE_HOUR',
  TWOFOUR_HOUR = 'TWOFOUR_HOUR',
}

export enum FormulaResultType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export enum NumberFormat {
  CURRENCY = 'CURRENCY',
  DECIMAL = 'DECIMAL',
  DECIMAL_WITH_COMMAS = 'DECIMAL_WITH_COMMAS',
  PERCENTAGE = 'PERCENTAGE',
}

export interface ILookupTypeOptions {
  type: ColumnType.LOOKUP;
  recordReferenceColumnId: string;
  foreignLookupColumnId: string;
  errorCode?: string;

  lookupOptions?: ISelect[];
  lookupDateFormat?: DateFormat;
  lookupIncludeTime?: boolean;
  lookupTimeFormat?: TimeFormat;
  lookupCurrencyFormat?: string;
  lookupUseGMT?: boolean;
  lookupDefaultNumber?: number;
  lookupPrecision?: number;
  lookupRatingMax?: number;
  lookupRatingStyle?: string;
  lookupColumnType: Exclude<ColumnType, ColumnType.NOOP | ColumnType.LOOKUP>;
  lookupForeignCoreId?: string;
  lookupForeignTableId?: string;
  lookupForeignWorkspaceId?: string;
  lookupResultType?: FormulaResultType;
  lookupNumberFormat?: NumberFormat;
}
